import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ChatHttpService {

  constructor(private http: HttpClient,
              private router: Router) {
  }

  getChats(id: number | null = null): Observable<ChatRoom[]> {
    return this.http.post<ChatRoom[] | ChatRoom>(environment.apiUrl + 'convicted/chat/get', {ChatID: id})
      .pipe(map(items => {
        if (Array.isArray(items) === true) {
          return items as ChatRoom[];
        }
        return [items] as ChatRoom[];
      }));
  }

  chatCreate(data: RequestCreateChat): Observable<any> {
    return this.http.post(environment.apiUrl + 'convicted/chat/create', data);
  }

  chatDelete(data: RequestDeleteChat): Observable<any> {
    return this.http.post(environment.apiUrl + 'convicted/chat/delete', data);
  }

  chatMessageAdd(data: RequestAddMsgForChat): Observable<ChatMessage> {
    return this.http.post<ChatMessage>(environment.apiUrl + 'convicted/chat/msg/add', data);
  }

  inviteChat(data: RequestInviteChat): Observable<any> {
    return this.http.post(environment.apiUrl + 'convicted/chat/invite', data);
  }
}


export interface RequestInviteChat {
  UserPhone: string;
  UserEmail?: string;
}

export interface RequestCreateChat {
  UserPhone: string;
}

export interface RequestAddMsgForChat {
  ChatID: number,
  MsgText: string,
}

export interface RequestDeleteChat {
  ChatID: number
}

export interface ChatMessage {
  MsgID: number,
  ChatID: number,
  MsgDT: Date,
  MsgText: string,
  MsgAuthor: string,
  MsgType: string,
  MsgState: 'Approved' | 'Moderation' | 'Declined' | 'DateGroup'; // ?
  MsgIsRead: boolean,
  Attachments: ChatAttachments[],
}

export interface ChatAttachments {
  AttachID: number;
  AttachName: string;
  AttachSize: number;
  AttachState: 'Approved' | 'Moderation' | 'Declined';
  AttachThumbURL: string;
  AttachURL: string;
}


export interface ChatRoom {
  ChatID: number,
  ChatLastMsgDT: Date,
  User: {
    UserID: number;
    UserPhone: string;
    UserEmail: string;
    UserFirstName: string;
    UserMidName: string;
    UserLastName: string;
    IsOnline: boolean;
    UserRegConfirmed: boolean;
    UserNextInviteDT: string;
    UserLastInviteDT: string;
    UserCanBeInvited: boolean;
  },
  Convicted: {
    CardNumber: number;
    ConvictedID: number,
    ConvictedFirstName: string,
    ConvictedMidName: string,
    ConvictedLastName: string,
    ConvictedBirthDate: string,
    IsOnline: boolean;
    Organisation: {
      OrgName: string,
      OrgNameFull: string,
      OrgCity: string,
      OrgAddress: string,
      OrgDescription: string,
      OrgCoordinates: string,
      Region: {
        RegionName: string,
      }
    }
  },
  UnreadMsgCount: any[],
  Messages: ChatMessage[],
}
